import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export const OSM_TILES = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

/** Подложка OSM: `detectRetina` на экране с плотностью выше 1 берёт тайлы следующего зума половинного размера, иначе тайл 256 px растягивается и карта пикселит. */
export function osmTileLayer(): L.TileLayer {
  return L.tileLayer(OSM_TILES, { attribution: OSM_ATTRIBUTION, maxZoom: 19, detectRetina: true });
}

export const DEFAULT_CENTER: L.LatLngExpression = [44.7866, 20.4489];

/** Дефолтные png-маркеры Leaflet не резолвятся в сборке Vite, поэтому точки рисуются divIcon. */
export function dotIcon(color: string, size = 12): L.DivIcon {
  return L.divIcon({
    className: '',
    html: `<span style="display:block;width:${size}px;height:${size}px;border-radius:50%;background:${color};border:2.5px solid #101312;box-shadow:0 1px 5px rgba(0,0,0,.45)"></span>`,
    iconSize: [size + 5, size + 5],
    iconAnchor: [(size + 5) / 2, (size + 5) / 2],
  });
}
